// Named keys all start with a capital letter followed by one or more letters or numbers
export const rNonPrintableKey = /^[A-Z][A-Za-z0-9]/;
